/** JSON with the same property/array order and exact signed zero. Both JSON.parse and the bundler
 * retain a written -0, whereas JSON.stringify would silently change its numeric sign. */
export function planJson(value: unknown): string {
  if (typeof value === 'number')
    return Object.is(value, -0) ? '-0' : Number.isFinite(value) ? String(value) : 'null';
  if (Array.isArray(value)) return `[${value.map(planJson).join(',')}]`;
  if (value !== null && typeof value === 'object') {
    const fields = Object.entries(value)
      .filter(([, field]) => field !== undefined)
      .map(([key, field]) => `${JSON.stringify(key)}:${planJson(field)}`);
    return `{${fields.join(',')}}`;
  }
  const text = JSON.stringify(value);
  if (text === undefined) throw new Error('World plans contain a value that cannot be serialized');
  return text;
}
